import { gql } from 'urql';

export const BranchInfo = gql`
  fragment BranchInfo on Branch {
    id
    name
    shorthand
    organization {
      id
      slug
    }
  }
`;
